import { TrackerInstance } from './tracker-factory';

class KissmetricsAdapter implements TrackerInstance {
  // @ts-ignore
  private config: any;

  constructor(config?: any) {
    this.config = config;
  }

  public report() {
    return true;
  }
}

export default KissmetricsAdapter;
